import { AcType, Path, StoreKey } from "@common/constans";
import { LoaderMode, SearchMode, StorageType } from "@common/enum";
import { IAirCheckinInfo, IAirCheckinRequest, IAirCheckinSeatMap, IAirCheckinSeatMapInitData, IAirCheckinSeatMapRegister, IAirportTransfer, IAncillary, IAncillaryAvailabilityRequest, IAncillaryAvailabilityResponse, IAncillaryPricingResponse, IAvailabilityRequest, IAvalaibilityResponse, IContactAddress, ICountry, IFeedback, IFlightPoint, IMember, IMessage, IModificationPricingInfo, IModificationRequest, IOriginDestination, IPaxTypeQuantity, IPerson, IPnrInfo, IPricingRequest, IPricingResponse, IRoute, ITransactionTimeout, ITraveler, TripType } from "@common/models";
import { IBanner, ICmsAncillary, IFleet, IGender } from "@common/models/CMS";
import { IHeaderStyle } from "@common/models/HeaderStyle";
import { IPreloader } from "@common/models/Preloader";
import { ICaptchaPopup } from "@components/CaptchaPopup";
import { IDateRange } from "@components/general/form/DateRangeInput";
import { IRoutePicker } from "@components/general/form/RoutePicker";
import { ILocale, IValidationErrors } from "@core/index";
import { Account } from "@service/Account";
import Storage from "@service/Storage";
import { getWidth } from "@utilize/Util";

export interface IAppState {
    airCheckinRequest: IAirCheckinRequest;
    airCheckinInfo: IAirCheckinInfo;
    airCheckinSelectedTravelers: ITraveler[];
    airportTransfers: IAirportTransfer[];
    airports: IFlightPoint[];
    ancillaryAvailabilityRequest: IAncillaryAvailabilityRequest;
    ancillaryAvailabilityResponse: IAncillaryAvailabilityResponse;
    ancillaryPricingResponse: IAncillaryPricingResponse;
    availabilityPaxTypeQuantity: IPaxTypeQuantity;
    availabilityRequest: IAvailabilityRequest;
    availabilityResponse: IAvalaibilityResponse;
    banners: IBanner[];
    bookingTransactionTimeout: ITransactionTimeout;
    checkPrice: boolean;
    cmsAncillaries: ICmsAncillary[];
    contactRefNumber: string;
    contacts: ITraveler[];
    countriesData: ICountry[];
    contactAddresses: IContactAddress[];
    currentStep: number;
    errors: IMessage[];
    fleets: IFleet[];
    feedback: IFeedback;
    footerMode: "Full" | "Minimal" | "None";
    genders: IGender[];
    headerStyle: IHeaderStyle;
    inactiveSearchPanel: boolean;
    languages: ILocale[];
    locale: string;
    manageSelectPassenger: number;
    missedAncillaries: IAncillary[];
    modificationRequest: IModificationRequest;
    modificationPricingResponse: IModificationPricingInfo;
    newRoute: string;
    passengers: ITraveler[];
    personList: IPerson[];
    pnrInfo: IPnrInfo;
    priceRequest: IPricingRequest;
    priceResponse: IPricingResponse;
    rangeOptions: IDateRange;
    captchaPopup: ICaptchaPopup;
    refreshTokenError: boolean;
    routeOptions: IRoutePicker;
    routes: IRoute[];
    searchMode: SearchMode;
    seatMap: IAirCheckinSeatMap;
    seatMapInitData: IAirCheckinSeatMapInitData,
    seatMapRegister: IAirCheckinSeatMapRegister,
    selectedFlights: IOriginDestination[];
    selectedAncillaries: IAncillary[];
    preloader: IPreloader;
    showHeaderSkeleton: boolean;
    showRetryButton: boolean;
    showBackButton: boolean;
    toasts: IMessage[];
    transactionTimeout: ITransactionTimeout;
    user: IMember;
    validationErrors: IValidationErrors;
    windowWidth: number;
}

export function getInitialState(): IAppState {
    return {
        airCheckinRequest: {},
        airCheckinInfo: {},
        airCheckinSelectedTravelers: [],
        airportTransfers: [],
        airports: [],
        ancillaryAvailabilityRequest: {},
        ancillaryAvailabilityResponse: {},
        ancillaryPricingResponse: {},
        availabilityPaxTypeQuantity: {
            adt: 1,
            chd: 0,
            inf: 0,
            yad: 0
        },
        availabilityRequest: {
            originDestionations: [{}],
            paxTypeQuantity: {
                adt: 1,
                chd: 0,
                inf: 0,
                yad: 0
            },
            tripType: TripType.OneWay
        },
        availabilityResponse: {},
        banners: [],
        bookingTransactionTimeout: {},
        checkPrice: false,
        cmsAncillaries: [],
        contactRefNumber: "-1",
        contactAddresses: [],
        contacts: [],
        countriesData: [],
        currentStep: Storage.get(StoreKey.CurrentStep, StorageType.Session) || window.location.href.includes(Path.Booking.SelectFlight) ? 2 : 1,
        errors: [],
        footerMode: "Full",
        fleets: [],
        feedback: { attachments: [] },
        genders: [],
        headerStyle: { menuStyle: "Solid", menuColor: "White" },
        inactiveSearchPanel: false,
        languages: [],
        locale: "",
        manageSelectPassenger: 0,
        missedAncillaries: [],
        modificationRequest: {},
        modificationPricingResponse: {},
        newRoute: "",
        passengers: [],
        personList: [],
        pnrInfo: {},
        preloader: {
            show: false,
            mode: LoaderMode.Blur
        },
        priceRequest: {},
        priceResponse: {},
        rangeOptions: {
            arrival: {
                name: ""
            },
            departure: {
                name: ""
            }
        },
        routeOptions: {
            destination: {
                name: ""
            },
            origin: {
                name: ""
            }
        },
        captchaPopup: {
            error: false,
            loading: false,
            visible: false,
        },
        refreshTokenError: false,
        routes: [],
        searchMode: SearchMode.Create,
        selectedFlights: [],
        showHeaderSkeleton: false,
        showRetryButton: false,
        showBackButton: false,
        seatMap: {},
        seatMapInitData: {
            data: AcType,
            choseData: "",
            SVGPoint: "",
            seatMapDimension: "",
            noseData: false,
        },
        seatMapRegister: {},
        selectedAncillaries: [],
        toasts: [],
        transactionTimeout: {},
        user: Account.getUser() || {},
        validationErrors: [],
        windowWidth: getWidth(),
    }
}